import React, {useContext} from 'react';
import { AuthContext } from '../../../context/AuthProvider';

export const LogoutButton = () => {
    const { signOut } = useContext(AuthContext);

    return (
        <button type="button" className="btn btn-danger" onClick={signOut}>Logout</button>
    )
};